interface CMSUrls extends Record<string, string> {
  local: string;
  staging: string;
  live: string;
  production: string;
}

export const cmsUrls: CMSUrls = {
  local: "http://localhost:1337",
  staging: "https://dev.backend.universalmusic.digital",
  live: "https://backend.universalmusic.digital",
  production: "https://backend.universalmusic.digital",
  prod: "https://backend.universalmusic.digital",
};

export function getUrl(urlOrKey: string): string {
  if (urlOrKey.startsWith("http://") || urlOrKey.startsWith("https://")) {
    return urlOrKey;
  }
  if (urlOrKey === "local") {
    // Local uses the current app's hostname so that we can access from
    // test from other LAN addresses than localhost
    return "http://" + window.location.hostname + ":1337";
  }
  const url = cmsUrls[urlOrKey];
  if (!url) {
    throw new Error(`Invalid URL key '${urlOrKey}'`);
  }
  return url;
}
